import React from 'react';
import Tooltip from './Tooltip';

export default function InfoBadge({ text, position = 'top' }) {
  return (
    <Tooltip text={text} position={position}>
      <button
        type="button"
        className="inline-flex items-center justify-center w-4 h-4 rounded-full bg-dark-surface border border-dark-border text-gray-500 hover:text-safe hover:border-safe/30 transition-colors text-xs cursor-help"
        aria-label="Plus d'informations"
        tabIndex={0}
      >
        ?
      </button>
    </Tooltip>
  );
}
